import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { inviteOutlinedButtonSx } from "./inviteTypography";

export interface InviteDisconnectButtonProps {
  variant: "success" | "already_connected";
  disconnectLoading: boolean;
  onDisconnect: () => void;
  disabled?: boolean;
}

export const InviteDisconnectButton: React.FC<InviteDisconnectButtonProps> = ({
  variant,
  disconnectLoading,
  onDisconnect,
  disabled = false,
}) => (
  <Button
    variant="outlined"
    color="error"
    onClick={onDisconnect}
    disabled={disconnectLoading || disabled}
    startIcon={disconnectLoading ? <CircularProgress size={20} /> : null}
    fullWidth
    sx={(theme) => ({
      ...inviteOutlinedButtonSx(theme),
      "&:hover": {
        borderColor: theme.palette.error.main,
        bgcolor: theme.palette.action.hover,
      },
    })}
  >
    {disconnectLoading
      ? "Desconectando…"
      : variant === "already_connected"
        ? "Verificar y desconectar"
        : "Desconectar cuenta"}
  </Button>
);

export default InviteDisconnectButton;
